export { HighlightPopover, type HighlightPopoverProps } from './HighlightPopover';
